const pym = require("./lib/pym");
const debounce = require("./lib/debounce");

const MapboxGL = require("mapbox-gl");
const {Map, NavigationControl, Popup} = MapboxGL;
const topojson = require("topojson-client");

const legend = require("./color-legend");

const edData = require("../../data/eds.json");
const eds = topojson.feature(edData, edData.objects.eds);

const container = document.querySelector(".map-container .map");
const overlay = document.querySelector(".map-container .map-overlay");

const keyContainerMixed = document.querySelector(".chart-key-mixed");
const updateMixed = legend(keyContainerMixed, [-40, -20, 0, 20, 40], ['#b2182b', '#ef8a62', '#fddbc7', '#d1e5f0', '#67a9cf', '#2166ac']);

const map = new Map({
  container: container,
  style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
  fadeDuration: 0,
  scrollZoom: false,
  dragRotate: false,
  maxZoom: 16,
  maxPitch: 0
});

map.once("load", async () => {
  map.fitBounds(topojson.bbox(edData), {
    padding: 20,
    duration: 0
  });

  map.addControl(new NavigationControl({
    showCompass: false
  }), "top-right");
  map.touchZoomRotate.disableRotation();

  // Sources

  map.addSource("eds", {
    "type": "geojson",
    "data": eds
  });

  // Layers

  map.addLayer({
    "id": "eds",
    "type": "fill",
    "source": "eds",
    "paint": {
      "fill-color": [
        "case",
        ["to-boolean", ["get", "margin"]],
        [
          "step",
          ["to-number", ["get", "margin"], 0],
          '#b2182b', -40,
          '#ef8a62', -20,
          '#fddbc7', 0,
          '#d1e5f0', 20, 
          '#67a9cf', 40,
          '#2166ac'
        ],
        "#ccc"
      ],
      "fill-opacity": 0.6,
    }
  }, "watername_ocean");

  map.addLayer({
    "id": "borders",
    "type": "line",
    "source": "eds",
    "paint": {
      "line-width": 0.2,
      "line-color": "#f6f6f6"
    }
  }, "watername_ocean");

  map.addLayer({
    "id": "outlines",
    "type": "line",
    "source": "eds",
    "visibility": "none",
    "filter": ["boolean", false],
    "paint": {
      "line-width": 2,
      "line-color": "#000"
    }
  }, "watername_ocean");

  addPopup(map);
});

function addPopup(map) {
  const popup = new Popup({closeButton: false, closeOnClick: false});
  const layer = "eds";

  const onMouseMove = debounce((coordinates, props) => {
    const total = props.dem + props.rep + props.other;

    const ad = String(props.ed).substr(0, 2);
    const ed = String(props.ed).substr(2);

    const description = `<div class="popup-content">
      <div class="report">
        <h3>Assembly District ${ad} <br />Election District ${ed}</h3>
        <table class="results">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Party</th>
              <th class="number">Votes</th>
              <th class="number">Pct.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Eric Adams</td>
              <td>DEM</td>
              <td class="number">${props.dem}</td>
              <td class="number">${total !== 0 ? (props.dem/total).toLocaleString("en-US", {style: "percent", maximumFractionDigits: 1, minimumFractionDigits: 1}) : "0%"}</td>
            </tr>
            <tr>
              <td>Curtis Sliwa</td>
              <td>REP</td>
              <td class="number">${props.rep}</td>
              <td class="number">${total !== 0 ? (props.rep/total).toLocaleString("en-US", {style: "percent", maximumFractionDigits: 1, minimumFractionDigits: 1}) : "0%"}</td>
            </tr>
            <tr>
              <td>Other</td>
              <td></td>
              <td class="number">${props.other}</td>
              <td class="number">${total !== 0 ? (props.other/total).toLocaleString("en-US", {style: "percent", maximumFractionDigits: 1, minimumFractionDigits: 1}) : "0%"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>`;

    map.setFilter("outlines", ["==", ["get", "ed"], props.ed]);
    popup.setLngLat(coordinates).setHTML(description);
  }, 60);

  map.on("mousemove", layer, e => {
    const coordinates = e.lngLat;
    const props = e.features[0].properties;

    onMouseMove(coordinates, props);
  });

  map.on("mouseenter", layer, () => {
    map.setLayoutProperty("outlines", "visibility", "visible");
    map.getCanvas().style.cursor = "pointer";
    popup.addTo(map);
  });

  map.on("mouseleave", layer, () => {
    map.setLayoutProperty("outlines", "visibility", "none");
    map.getCanvas().style.cursor = "";
    popup.remove();
  });
}